export class GoalProgressValueDto {

    constructor(public value: number) {
    }
}